import { baseRestV4Api as api } from '../base/base-restV4-api';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getTheme: build.query<GetThemeApiResponse, GetThemeApiArg>({
      query: () => ({ url: `/v4/theme` }),
    }),
    getEnvironment: build.query<GetEnvironmentApiResponse, GetEnvironmentApiArg>({
      query: () => ({ url: `/v4/schemas/current` }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as restV4Api };
export type GetThemeApiResponse = /** status 200 OK */ {
  [key: string]: string;
};
export type GetThemeApiArg = void;
export type GetEnvironmentApiResponse = /** status 200 OK */ {
  [key: string]: string;
};
export type GetEnvironmentApiArg = void;
export const { useGetThemeQuery, useLazyGetThemeQuery, useGetEnvironmentQuery, useLazyGetEnvironmentQuery } =
  injectedRtkApi;
